module.exports = __webpack_public_path__ + "static/media/google-authenticator-icon.9c031703.png";